import {Component, OnInit} from '@angular/core';
import {Shipment} from '../services/shipment';
import {ShipmentRoute} from '../services/shipment-route';
import {ActivatedRoute} from '@angular/router';
import {GetShipmentsOptions, ShipmentsService} from '../services/shipments.service';
import {ShipmentRoutesService} from '../services/shipment-routes.service';
import {ShipmentDriversService} from '../services/shipment-drivers.service';
import {BranchesService} from '../services/branches.service';
import {ApiResponse} from "@hassel-it/angular-common";
import * as moment from "moment";

@Component({
    providers: [ShipmentRoutesService, BranchesService, ShipmentDriversService],
    selector: 'app-picker-queue',
    templateUrl: './picker-queue.component.html'
})
export class PickerQueueComponent implements OnInit {

    options: GetShipmentsOptions = null;
    branches: any = [{'key': ['hoe'], 'name': 'Aarhus'}];
    shipments: Shipment[];
    shipmentRoutes: ShipmentRoute[];
    loadingShipments: boolean;

    constructor(
        public activatedRoute: ActivatedRoute,
        public shipmentsService: ShipmentsService,
        public shipmentRoutesService: ShipmentRoutesService,
        public shipmentDriversService: ShipmentDriversService,
    ) {
    }

    ngOnInit(): void {

        this.resetOptions();
        /**
         * Shipment routes
         */
        this.shipmentRoutesService.getShipmentRoutes().then(shipmentRoutes => {
            this.shipmentRoutes = shipmentRoutes;
        });
    }

    dateChanged(event) {
    }

    routeChanged(event) {
    }

    reloadShipments(zoom: boolean = false, displayPopover: boolean = false) {

        this.loadingShipments = true;
        this.shipments = [];

        let options: GetShipmentsOptions;
        options = this.options;
        options.endDate = options.startDate;

        this.shipmentsService.getShipments(1, options).then((response) => {
            this.loadingShipments = false;
            this.shipments = response.results;

        }, () => {
            this.loadingShipments = false;
            this.shipments = [];

        });
    }

    resetOptions() {
        this.options = {
            valid_coordinates: true,
            all: true,
            startDate: null,
            endDate: null,
            dateField: 'shipping_date',
            showTenFourShipment: true,
            showPostNordShipment: false,
            showGLSShipment: false,
            showDanskeFragtmaendShipment: false,
            branch: ['hoe'],
            order_reference: null,
            nota_number: null,
            product_number: null,
            contact_information_adress: null,
            contact_information_name: null,
            contact_information_phone: null,
            contact_information_email: null,
            tracking_number: null,
            isSearching: false,
            sort: 'shipping_date',
            statusFilter: 'ready_picking',
            direction: 'ASC',
            combineEvents: true
        };
    }

}
